const ProgressBar = ({ value, fillClassName, frameClassName }) => {
    return (
        <div className={`h-1 flex rounded-full ${frameClassName ? frameClassName : ' bg-sf-gray-50'}`}>
            <div className={`h-full rounded-full ${fillClassName}`} style={{ width: `${value}%` }}></div>
        </div>
    );
};

export default ProgressBar;
